import { Skeleton } from "@mui/material";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import InfraccionesPorMes from "../InfraccionesPorMes";
import { useEffect } from "react";
import { useEstadisticasStore } from "../../../../store/estadisticasStore";
import { getEstadisticasGeneralHandler } from "../../../../handlers/estadisticasHandler";
import { MuniSpinner2 } from "../../../../components";


const InfoGeneral = ({ estadisticas }) => {

    const { loads } = useGeneralAppStore();
    const { general } = useEstadisticasStore();

    useEffect(() => {
        if (!general) {
            getEstadisticasGeneralHandler();
        }
        return () => {
            useEstadisticasStore.setState({ general: null })
        }
    }, [])
    // console.log(general);
    console.log(loads);


    return (
        <section className="d-flex flex-wrap py-5">
            <h4 className="text-center mb-0 w-100">Información general</h4>
            <section className="py-5 d-flex flex-column gap-2 col-4 px-4">
                <div className="d-flex gap-3 w-100 d-flex justify-content-start">
                    <h6 className=" m-0">CANTIDAD TOTAL DE INFRACCIONES:</h6>
                    {
                        // loads.includes('estadisticas_vehiculos')
                        loads.includes('estadisticas')
                            ? <Skeleton animation="wave" variant="rounded" width={75} height={38} />
                            : <h6 className="m-0" style={{ color: "#1976D2" }}>{general?.total_infracciones}</h6>
                    }

                </div>

                <div className="d-flex gap-3 w-100 d-flex justify-content-start">
                    <h6 className="m-0">INFRACCIONES DE EMPRESAS:</h6>
                    {
                        loads.includes('estadisticas')
                            ? <Skeleton animation="wave" variant="rounded" width={75} height={30} />
                            : <h6 className="m-0" style={{ color: "#1976D2" }}>{general?.infracciones_empresas}</h6>
                    }
                </div>

                <hr />

                <div className="d-flex gap-3 w-100 d-flex justify-content-start">
                    <h6 className="m-0">INFRACCIONES LOCALES:</h6>
                    {
                        loads.includes('estadisticas')
                            ? <Skeleton animation="wave" variant="rounded" width={75} height={30} />
                            : <h6 className="m-0" style={{ color: "#1976D2" }}>{general?.infracciones_locales}</h6>
                    }
                </div>
                <div className="d-flex gap-3 w-100 d-flex justify-content-start">
                    <h6 className="m-0">INFRACCIONES EXTRAÑA JURISDICCION:</h6>
                    {
                        loads.includes('estadisticas')
                            ? <Skeleton animation="wave" variant="rounded" width={75} height={30} />
                            : <h6 className="m-0" style={{ color: "#1976D2" }}>{general?.infracciones_extraña_jurisdiccion}</h6>
                    }
                </div>

                <hr />

                <div className="d-flex gap-3 w-100 d-flex justify-content-start">
                    <h6 className="m-0">INFRACCIONES DIGITALES:</h6>
                    {
                        loads.includes('estadisticas')
                            ? <Skeleton animation="wave" variant="rounded" width={75} height={30} />
                            : <h6 className="m-0" style={{ color: "#1976D2" }}>{general?.infracciones_digitales}</h6>
                    }
                </div>
                <div className="d-flex gap-3 w-100 d-flex justify-content-start">
                    <h6 className="m-0">INFRACCIONES FISICAS:</h6>
                    {
                        loads.includes('estadisticas')
                            ? <Skeleton animation="wave" variant="rounded" width={75} height={30} />
                            : <h6 className="m-0" style={{ color: "#1976D2" }}>{general?.infracciones_fisicas}</h6>
                    }
                </div>
                <hr />

                {/*    <div className="d-flex gap-3 w-100 d-flex justify-content-start">
                    <h6 className="m-0">INFRACCIONES AUTOS:</h6>
                    {
                        loads.includes('estadisticas')
                            ? <Skeleton animation="wave" variant="rounded" width={75} height={30} />
                            : <h6 className="m-0" style={{ color: "#1976D2" }}>{general?.infracciones_autos}</h6>
                    }
                </div>
                <div className="d-flex gap-3 w-100 d-flex justify-content-start">
                    <h6 className="m-0">INFRACCIONES MOTOS:</h6>
                    {
                        loads.includes('estadisticas')
                            ? <Skeleton animation="wave" variant="rounded" width={75} height={30} />
                            : <h6 className="m-0" style={{ color: "#1976D2" }}>{general?.infracciones_motos}</h6>
                    }
                </div> */}

            </section>
            <section className="col-8">
                {console.log(loads.includes('estadisticas'))}
                {console.log(general?.por_mes)}
                {
                    <section className=" col-12 mx-auto py-5">
                        <div className="d-flex justify-content-end">
                            <h6 className="d-flex justify-content-center m-0 " style={{ width: "95%" }}>Infracciones por mes</h6>
                        </div>
                        <div style={{ height: "530px" }} >
                            {
                                loads.includes('estadisticas') ?
                                    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                                        <MuniSpinner2 />
                                    </div> :
                                    general?.por_mes &&
                                    <InfraccionesPorMes estadisticas={general?.por_mes} spinner={loads.includes('estadisticas')} />
                            }
                        </div>
                    </section>

                }

            </section>
        </section>
    );
}
export default InfoGeneral;